import React, { useState } from "react"
import ReactHtmlParser from "react-html-parser"
import Slider from "react-slick"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import useWindowWidth from "../../hooks/useWindowWidth"
import useKeyboardNavigation from "../../hooks/useKeyboardNavigation"

export default function ServiceLinkCardContainer({ serviceLinkCards, headline, backgroundColor, bottomPadding, topPadding }) {
  const windowWidth = useWindowWidth()
  const keyboardNavigating = useKeyboardNavigation()

  const bgColor = SelectionFactoryHelper.getFromSelectionFactory(backgroundColor, false) || ""
  const tPadding = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding, false) || ""
  const bPadding = SelectionFactoryHelper.getFromSelectionFactory(topPadding, false) || ""

  const htmlServiceLinkCards =
    serviceLinkCards && serviceLinkCards.length > 0
      ? serviceLinkCards.map((card, index) => {
          return (
            <ServiceLinkCard
              key={card.cardHeader + index}
              header={card.cardHeader}
              subtext={card.cardSubtext}
              svg={card.svg}
              link={card.link}
              target={card.target}
              windowWidth={windowWidth}
              keyboardNavigating={keyboardNavigating}
            />
          )
        })
      : undefined

  var settings = {
    dots: windowWidth < 950 ? true : false,
    arrows: windowWidth < 950 ? false : true,
    infinite: false,
    slidesToScroll: 1,
    swipe: true,
    variableWidth: true,
  }

  const htmlHeadline = ReactHtmlParser(headline)

  return (
    <section className={`service-link-card-container ${bgColor} ${tPadding} ${bPadding}`}>
      <h2 className="service-link-container-headline">{htmlHeadline}</h2>
      {htmlServiceLinkCards && htmlServiceLinkCards.length > 0 ? (
        <div className="w--wider">
          {windowWidth < 950 ? (
            <Slider {...settings}>{htmlServiceLinkCards}</Slider>
          ) : (
            <div className="service-link-cards">{htmlServiceLinkCards}</div>
          )}
        </div>
      ) : (
        <div className="no-content"></div>
      )}
    </section>
  )
}

function ServiceLinkCard({ svg, header, subtext, link, target, windowWidth, keyboardNavigating }) {
  const [isHovered, setIsHovered] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  function handleMouseEvent() {
    if (!isFocused) setIsHovered(!isHovered)
  }

  function handleFocusEvent() {
    setIsFocused(!isFocused)
    if (isHovered) setIsHovered(!isHovered)
  }

  const selectedSvg = SelectionFactoryHelper.getFromSelectionFactory(svg)
  const selectedLinkTarget = SelectionFactoryHelper.getFromSelectionFactory(target)

  return (
    <div className={`grid-item${keyboardNavigating && isFocused ? " focus-visible" : ""}`}>
      <a
        onMouseEnter={windowWidth >= 768 ? () => handleMouseEvent() : undefined}
        onMouseLeave={windowWidth >= 768 ? () => handleMouseEvent() : undefined}
        onFocus={() => handleFocusEvent()}
        onBlur={() => handleFocusEvent()}
        href={link}
        target={selectedLinkTarget || "_blank"}
      >
        {selectedSvg ? (
          <svg className={`svg-icon svg-icon--${selectedSvg}`}>
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`/dist/svg/symbols.svg#svg-${selectedSvg}`}>
              &nbsp;
            </use>
          </svg>
        ) : (
          <div className="no-svg"></div>
        )}
        <div className="servicelinkcard">
          <div className="flex-container">
            <div className="textarea-header">
              <h3 className={isHovered || isFocused ? "is-hovered" : ""}>{header}</h3>
            </div>
            <p className={`maintext${isHovered || isFocused ? " is-hovered" : ""}`}>{subtext}</p>
          </div>
        </div>
      </a>
    </div>
  )
}
